"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MessageBroadcastOut = void 0;
class MessageBroadcastOut {
    constructor() {
    }
    static getAttributeTypeMap() {
        return MessageBroadcastOut.attributeTypeMap;
    }
}
exports.MessageBroadcastOut = MessageBroadcastOut;
MessageBroadcastOut.discriminator = undefined;
MessageBroadcastOut.attributeTypeMap = [
    {
        "name": "id",
        "baseName": "id",
        "type": "string",
        "format": ""
    },
    {
        "name": "status",
        "baseName": "status",
        "type": "BackgroundTaskStatus",
        "format": ""
    },
    {
        "name": "task",
        "baseName": "task",
        "type": "BackgroundTaskType",
        "format": ""
    }
];
//# sourceMappingURL=MessageBroadcastOut.js.map